import React from "react";
import { Text } from "react-native";
import { styles } from "./styles";

const Linkify = props => {
  const { children } = props;
  const splied_text = children.split(" ");
  return (
    <Text style={styles.description}>
      {splied_text.map(value => {
        if (value.match(/https?:\/\/[^\s]+/)) {
          return (
            <a href={value.trim()} target="_blank">
              {value + " "}
            </a>
          );
        }
        return `${value} `;
      })}
    </Text>
  );
};

export default Linkify;
